import { useContext } from "react";
import { PlannerContext } from "../../../context/planner/PlannerContext";
import DayConfig from "./day/DayConfig";
import InsertBlock from "./block/InsertBlock";
import EditBlock from "./block/EditBlock";
import TemplateSelect from "./template/TemplateSelect";

const ToolSwitcher = () => {
  const { selectedTool } = useContext(PlannerContext);

  switch (selectedTool) {
    case "templateSelect":
      return <TemplateSelect />;
    case "dayConfig":
      return <DayConfig />;
    case "insertBlock":
      return <InsertBlock />;
    case "editBlock":
      return <EditBlock />;
    default:
      return <TemplateSelect />;
  }
};

export default ToolSwitcher;
